import styled from 'styled-components';

export const Container = styled.div`
  .MuiOutlinedInput-input {
    padding: 14px 14px;

    & ::selection {
      border: none;
    }
  }

  .MuiChip-deleteIcon {
    width: 16px;
    height: 16px;
    color: black;
  }

  .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] {
    padding: 4px;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid #b3b3b3;

    &:hover {
      border: none;
    }
  }

  .MuiChip-root {
    margin: 3px;
    max-width: calc(70% - 2px);
  }
`;

export const AvatarComponentContainer = styled.div`
  li {
    display: flex;
    align-items: center;
    gap: 4px;
    height: 38px;

    span {
      margin-left: 4px;
    }
  }
`;
